<!--
� 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
-->

<div class="switch">
	@for (option of options; track option.value) {
		<button
			type="button"
			mat-button
			[ngClass]="{ active: selectedBtn === option.value }"
			(click)="selectedBtn = option.value; handleSwitch.emit(option.value)"
		>
			{{ option.label }}
		</button>
	}
</div>
